"use client";

import { clsx } from "@trydig/ui";
import { FilterIcon } from "~/components/icons/FilterIcon";
import { useFilterModal } from "~/features/products/ProductListingPage/components/FilterModal/useFilterModal";
import styles from "./FilterButton.module.css";

export const FilterButton = () => {
	const { isOpen, toggleModal } = useFilterModal();

	return (
		<button
			type="button"
			className={clsx(
				"transparent",
				"small",
				styles["filter-button"],
				isOpen === true && styles.active,
			)}
			onClick={toggleModal}
		>
			<FilterIcon color={isOpen === false ? "" : ""} />
			<span>Filter</span>
		</button>
	);
};
